import * as yup from 'yup';

export const postLoad = yup.object({
  origin: yup.string().nullable().required('origin is required'),
  destination: yup.string().nullable().required('Destination is required'),
  pickUp: yup
    .string()
    .nullable()
    .required('pick up date is required')
    .test(
      'is-current-or-future',
      'Date must be today or in the future',
      function (value) {
        if (!value) return true;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dateValue = new Date(value);
        return dateValue >= today;
      },
    ),
  dropOff: yup
    .string()
    .nullable()
    .test(
      'is-current-or-future',
      'Date must be today or in the future',
      function (value) {
        if (!Boolean(value)) return true;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dateValue = new Date(value as string);
        return dateValue >= today;
      },
    )
    .test(
      'is-after-or-equal-pickup',
      'Drop off date must be equal to or after pick up date',
      function (value: string | null | undefined) {
        if (!Boolean(value)) return true;
        const pickUpDate = (
          this.parent as { pickUp: string | null | undefined }
        ).pickUp;
        if (!Boolean(pickUpDate)) return true;
        const pickUpDateValue = new Date(pickUpDate as string);
        const dropOffDateValue = new Date(value as string);
        return dropOffDateValue >= pickUpDateValue;
      },
    ),
});
